import {BehaviorSubject} from 'rxjs';

export class RenderConfigModel {

    private _logoMini: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private _logoLarge: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private _color: BehaviorSubject<string> = new BehaviorSubject<string>('');
    private _menu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);


    get logoMini(): string {
        return this._logoMini.value;
    }

    set logoMini(value: string) {
        this._logoMini.next(value);
    }

    get logoLarge(): string {
        return this._logoLarge.value;
    }

    set logoLarge(value: string) {
        this._logoLarge.next(value);
    }

    get color(): string {
        return this._color.value;
    }

    set color(value: string) {
        this._color.next(value);
    }

    get menu(): boolean {
        return this._menu.value;
    }

    set menu(value: boolean) {
        this._menu.next(value);
    }
}
